import React from 'react'
import { Modal, Button, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { VoucherPreviewTable } from '../../vouchers/components/VoucherTable'

interface DepreciationVoucherModalProps {
  visible: boolean
  onClose: () => void
  onSubmit?: (date: string) => Promise<void>
  voucherData: any
  voucherDate?: string
  loading?: boolean
  submitting?: boolean
}

const DepreciationVoucherModal: React.FC<DepreciationVoucherModalProps> = ({
  visible,
  onClose,
  onSubmit,
  voucherData,
  voucherDate,
  loading = false,
  submitting = false
}) => {
  const { t } = useTranslation()

  const handleSubmit = async () => {
    if (onSubmit && voucherDate) {
      try {
        await onSubmit(voucherDate)
        onClose()
      } catch (error) {
        // Error is handled in the hook
      }
    }
  }

  const footerButtons = (
    <Space>
      <Button onClick={onClose} disabled={submitting}>
        {t('global:cancel')}
      </Button>
      <Button type="primary" onClick={handleSubmit} loading={submitting} disabled={!onSubmit || !voucherDate}>
        {t('global:confirm')}
      </Button>
    </Space>
  )

  return (
    <Modal
      title={t('investmentsPage:depreciationVoucherPreview')}
      open={visible}
      onCancel={onClose}
      footer={footerButtons}
      loading={loading}
      maskClosable={!submitting}
      closable={!submitting}
      width="90vw"
      style={{ maxWidth: 1200 }}
    >
      {voucherData && <VoucherPreviewTable vouchers={[voucherData]} />}
    </Modal>
  )
}

export default DepreciationVoucherModal
